import React, { useState } from 'react';
import FormGroup from "react-bootstrap/FormGroup";
import Label from "reactstrap/es/Label";
import Input from "reactstrap/es/Input";
import CustomInput from "reactstrap/es/CustomInput";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from 'moment';


function TournamentStep1(props) {

	const [selectedDate1, setSelectedDate1] = useState(moment().format());
	const [selectedDate2, setSelectedDate2] = useState(moment().format());
	const [selectedDate3, setSelectedDate3] = useState(moment().format());
	const [selectedDate4, setSelectedDate4] = useState(moment().format());

	const handleDateChange = date => {
		setSelectedDate1(date.format());
	};
	const handleDateChange2 = date => {
		setSelectedDate2(date.format());
	};
	const handleDateChange3 = date => {
		setSelectedDate3(date.format());
	};
	const handleDateChange4 = date => {
		setSelectedDate4(date.format());
	};

	return (
		<div>
			<FormGroup>
				<Label for="title">대회명</Label>
				<Input type="text" name="title" id="title" placeholder="Tournament Title"/>
			</FormGroup>
			<FormGroup>
				<MuiPickersUtilsProvider utils={MomentUtils}>
					<Label for="tournament_period">대회기간</Label>
					<div className="date-row">
						<KeyboardDatePicker
							disableToolbar
							variant="inline"
							format="L"
							margin="normal"
							id="tournament_start"
							label="Start"
							value={selectedDate1}
							onChange={handleDateChange}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
						/>
						<KeyboardDatePicker
							disableToolbar
							variant="inline"
							format="L"
							margin="normal"
							id="tournament_end"
							label="End"
							value={selectedDate2}
							onChange={handleDateChange2}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
						/>
					</div>
				</MuiPickersUtilsProvider>
			</FormGroup>

			<FormGroup>
				<MuiPickersUtilsProvider utils={MomentUtils}>
					<Label for="register_period">접수기간</Label>
					<div className="date-row">
						<KeyboardDatePicker
							disableToolbar
							variant="inline"
							format="L"
							margin="normal"
							id="register_start"
							label="Start"
							value={selectedDate3}
							onChange={handleDateChange3}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
						/>
						<KeyboardDatePicker
							disableToolbar
							variant="inline"
							format="L"
							margin="normal"
							id="register_end"
							label="End"
							value={selectedDate4}
							onChange={handleDateChange4}
							KeyboardButtonProps={{
								'aria-label': 'change date',
							}}
						/>
					</div>
				</MuiPickersUtilsProvider>
			</FormGroup>
			<FormGroup>
				<Label for="tools">계측도구</Label>
				<div>
					<CustomInput type="checkbox" id="tools_grip" label="Grip" inline defaultChecked/>
					<CustomInput type="checkbox" id="tools_tag" label="Tag" inline/>
				</div>
			</FormGroup>
			<FormGroup>
				<Label for="item">순위선정 항목</Label>
				<div>
					<CustomInput type="checkbox" id="item_length" label="Length" inline defaultChecked/>
					<CustomInput type="checkbox" id="item_weight" label="Weight" inline/>
					<CustomInput type="checkbox" id="item_count" label="Count" inline/>
				</div>
			</FormGroup>
			<FormGroup>
				<Label for="criteria">순위선정 기준</Label>
				<div>
					<CustomInput type="radio" name="criteria" id="criteria_1" value="5e57cb14aa3b8e8fe7702b00" label="최대" inline defaultChecked/>
					<CustomInput type="radio" name="criteria" id="criteria_2" value="5e57ccf0aa3b8e8fe7702ba9" label="최소" inline/>
					<CustomInput type="radio" name="criteria" id="criteria_3" value="5e57cd03aa3b8e8fe7702bb5" label="합산" inline/>
					<Input type="number" name="criteria_limit" id="criteria_limit" placeholder="limit - blank or 0 : No limit" />
				</div>
			</FormGroup>
			<FormGroup>
				<Label for="priority">순위선정 우선순위</Label>
				<div>
					<CustomInput type="radio" name="priority" id="priority_1" label="Length" value="5e57c861aa3b8e8fe77029fe" inline defaultChecked/>
					<CustomInput type="radio" name="priority" id="priority_2" label="Weight" value="5e57c8a7aa3b8e8fe7702a1f" inline/>
					<CustomInput type="radio" name="priority" id="priority_3" label="Count" value="5e57c8c1aa3b8e8fe7702a2f" inline/>
				</div>
			</FormGroup>
			<FormGroup>
				<Label for="public">공개여부</Label>
				<div>
					<CustomInput type="radio" name="public" id="public_1" label="공개" value="5e57ceb5aa3b8e8fe7702c73" inline defaultChecked/>
					<CustomInput type="radio" name="public" id="public_2" label="비공개" value="5e57ceccaa3b8e8fe7702c7d" inline/>
					<CustomInput type="radio" name="public" id="public_3" label="클랜원만 참여가능" value="5e57cf06aa3b8e8fe7702c95" inline/>
					<Input type="password" name="password" id="password" placeholder="password"/>
				</div>
			</FormGroup>
		</div>
	);
}

export default TournamentStep1;
